export default __webpack_public_path__ + "static/media/placeholder_dummy2016-goldschmiede01-mobile-de.68e5072c.png";